const performance = {
  state: {
    /**
     * 분석 기간 정보 객체
     * DatetimeRangeButton.vue의 dateTimeRange와 동일 데이터 가짐
     * @type {Object}
     */
    analysisDateData: {},
    /**
     * 분석 시점 (일시)
     * 분석하려는 특정 시점 정보로 차트에 plotline을 그리는 기준점이 된다.
     * @type {Date}
     */
    plotLineDatetime: null,
    /**
     * 기간 필터 컴포넌트 초기 값
     * 설정되어있지 않은 경우 컴포넌트에 설정된 default 값으로 설정되며, 해당 상태 값이 있는 경우
     * 상태 값 기준으로 기간 필터 컴포넌트 값을 설정하고 해당 상태를 null로 설정해준다.
     *
     * 사용자 정의 기간일 경우 다음과 같은 형태의 객체를 받아 처리한다.
     * { type: 'absolute', startDatetime: {Date}/{Number}, endDatetime: {Date}/{Number} }
     * @type {Object}
     */
    initialDatetimeRange: null,
    /**
     * initialDatetimeRange과 동일한 컴포넌트 초기 설정 값.
     * 화면 전환 시 설정된 기간 필터 컴포넌트 초기 값을 설정한다.
     * initialDatetimeRange과 다르게 router 모듈에서 관리되는 routingPath 값과 현재 route의 path 값이 동일한 경우에만 반영되도록 한다.
     * @type {[type]}
     */
    routingDatetimeRange: null,
    /**
     * 분석 시점 초기 값
     * 성능/운영 > 분석 차트에서 최초 로드 시 마지막 일시가 아닌 특정 시점 기준으로 분석이 필요할 때 설정한다.
     * @type {Date}
     */
    initialPlotLineDatetime: null,
    selectedObjDefineIds: [],
    selectedObjDefineIdsForPhysical: [],
    selectedVmsObjtypeIds: [],
    showDatetimeRangeButtonFlag: false,
    /**
     * 성능/운영 > 분석 차트에서 드래그하여 선택한 분석 기간 데이터를 저장한다.
     * @type {Boolean}
     */
    selectedAnalysisChartDateRange: null,
    /**
     * 이벤트 상세 분석에서 rsctypeId = SYSLOG rscId = UNCHECKED_SYSLOG 일경우 성능/운영 > 네트워크 노드 > 분석 > 시스템로그에 선택된 syslogRuleId가 필터이 되게 한다 [SKT 요청 개발]
     * @type {Integer}
     */
    syslogRuleId: null,
  },
  mutations: {
    /**
     * 분석 기간 정보 설정
     * @param  {[type]} state      [description]
     * @param  {[type]} dateObject [description]
     */
    setAnalysisDateData: (state, dateObject) => {
      state.analysisDateData = dateObject;
    },
    /**
     * 분석 시점 정보 설정
     * @param  {[type]} state    [description]
     * @param  {[type]} datetime [description]
     */
    setPlotLineDatetime: (state, datetime) => {
      state.plotLineDatetime = datetime;
    },
    /**
     * 초기 기간 필터 컴포넌트 값 설정
     * @author Ju
     * @param  {[type]} state         [description]
     * @param  {[type]} dateTimeRange [description]
     */
    setInitialDatetimeRange: (state, dateTimeRange) => {
      state.initialDatetimeRange = dateTimeRange;
    },
    /**
     * [라우팅] 초기 기간 필터 컴포넌트 값 설정
     * @author Ju
     * @param  {[type]} state         [description]
     * @param  {[type]} dateTimeRange [description]
     */
    setRoutingDatetimeRange: (state, dateTimeRange) => {
      state.routingDatetimeRange = dateTimeRange;
    },
    /**
     * 초기 분석 시점 설정
     * @author Ju
     * @param  {[type]} state    [description]
     * @param  {Date} datetime [description]
     */
    setInitialPlotLineDatetime: (state, datetime) => {
      state.initialPlotLineDatetime = datetime;
    },
    setObjDefineIds: (state, objDefineIds) => {
      state.selectedObjDefineIds = objDefineIds;
    },
    setObjDefineIdsForPhysical: (state, objDefineIds) => {
      state.selectedObjDefineIdsForPhysical = objDefineIds;
    },
    setVmsObjtypeIds: (state, objtypeIds) => {
      state.selectedVmsObjtypeIds = objtypeIds;
    },
    setShowDatetimeRangeButtonFlag: (state, value) => {
      state.showDatetimeRangeButtonFlag = value;
    },
    setAnalysisIsRelativeData: (state, isRelative) => {
      state.analysisDateData.isRelative = isRelative;
    },
    setSelectedAnalysisChartDateRange: (state, selectedDate) => {
      state.selectedAnalysisChartDateRange = selectedDate;
    },
    setSyslogRuleId: (state, syslogRuleId) => {
    	state.syslogRuleId = syslogRuleId;
    },
  },
  actions: {
    /**
     * 분석 기간 정보 설정
     * @author Ju
     * @param  {[type]} commit     [description]
     * @param  {[type]} dateObject [description]
     */
    setAnalysisDateData({ commit }, dateObject) {
      commit('setAnalysisDateData', dateObject);
    },
    /**
     * 분석 시점 정보 설정
     * @author Ju
     * @param  {[type]} commit   [description]
     * @param  {[type]} datetime [description]
     */
    setPlotLineDatetime({ commit }, datetime) {
      commit('setPlotLineDatetime', datetime);
    },
    /**
     * 초기 기간 필터 컴포넌트 값 설정
     * @author Ju
     * @param  {[type]} commit        [description]
     * @param  {[type]} dateTimeRange [description]
     */
    setInitialDatetimeRange({ commit }, dateTimeRange) {
      commit('setInitialDatetimeRange', dateTimeRange);
    },
    /**
     * [라우팅] 초기 기간 필터 컴포넌트 값 설정
     * @author Ju
     * @param  {[type]} commit        [description]
     * @param  {[type]} dateTimeRange [description]
     */
    setRoutingDatetimeRange({ commit }, dateTimeRange) {
      commit('setRoutingDatetimeRange', dateTimeRange);
    },
    /**
     * 초기 분석 시점 값 설정
     * @author Ju
     * @param  {[type]} commit   [description]
     * @param  {Date} datetime
     */
    setInitialPlotLineDatetime({ commit }, datetime) {
      commit('setInitialPlotLineDatetime', datetime);
    },
    setObjDefineIds({ commit }, objDefineIds) {
      commit('setObjDefineIds', objDefineIds);
    },
    setObjDefineIdsForPhysical({ commit }, objDefineIds) {
      commit('setObjDefineIdsForPhysical', objDefineIds);
    },
    setVmsObjtypeIds({ commit }, objtypeIds) {
      commit('setVmsObjtypeIds', objtypeIds);
    },
    showDatetimeRangeButton({ commit }) {
      commit('setShowDatetimeRangeButtonFlag', true);
    },
    hideDatetimeRangeButton({ commit }) {
      commit('setShowDatetimeRangeButtonFlag', false);
    },
    setAnalysisIsRelativeData({ commit }, isRelative) {
      commit('setAnalysisIsRelativeData', isRelative);
    },
    setSelectedAnalysisChartDateRange({ commit }, selectedDate) {
      commit('setSelectedAnalysisChartDateRange', selectedDate);
    },
    setSyslogRuleId({ commit }, syslogRuleId) {
    	commit('setSyslogRuleId', syslogRuleId);
    },
  },
};

export default performance;



// WEBPACK FOOTER //
// ./src/store/modules/performance.js